import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDashboardMiddle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"dashboard-middle"} maskId="square-filled-radius-0-stroke-1-IconDashboardMiddle"><path d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.4222 21.7031 14.7751 21.1679 16H12.5V8H11.5V16H2.83209C2.2969 14.7751 2 13.4222 2 12Z" fill="currentColor"/><path d="M3.33594 17C5.06498 19.989 8.2967 22 11.9981 22C15.6995 22 18.9312 19.989 20.6603 17H3.33594Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDashboardMiddle;
